import {
	ifAuthenticated,
	canAccess,
	AppTabs
} from '@/router/index'

import Drive from '@/components/modules/drive/Drive'

// Il path deve coincidere con 'router' del Config/config.php del backend:
// la sidebar e' generata da moduleListMenu() e costruisce il link come
// '/' + item.router.
export const drive = [
	{
		path: '/drive',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: { tabs: [{ to: '/drive/', text: 'Drive', module: 'drive' }] },
		children: [
			{
				path: '/drive/',
				name: 'drive-index',
				beforeEnter: (to, from, next) => { canAccess('module', 'drive', next) },
				component: Drive,
				meta: {
					title: 'Drive',
				}
			}
		]
	}
]
